import { cva } from "class-variance-authority";

export { default as Action } from "./Action.vue";
export { default as Swipeable } from "./Swipeable.vue";

export const actionVariants = cva(["min-w-full", "flex", "items-center"], {
    variants: {
        variant: {
            left: ["justify-start"],
            right: ["justify-end"],
        },
        color: {
            gray: ["bg-utility-gray-600"],
            brand: ["bg-utility-brand-600"],
            error: ["bg-utility-error-600"],
            warning: ["bg-utility-warning-600"],
            success: ["bg-utility-success-600"],
            "gray-blue": ["bg-utility-gray-blue-600"],
            "blue-light": ["bg-utility-blue-light-600"],
            blue: ["bg-utility-blue-600"],
            indigo: ["bg-utility-indigo-600"],
            purple: ["bg-utility-purple-600"],
            pink: ["bg-utility-pink-600"],
            orange: ["bg-utility-orange-600"],
        },
    },
    defaultVariants: {
        variant: "left",
        color: "gray",
    },
});
